export { redirectLike } from './like-message'
